module.exports = __webpack_public_path__ + "img/2f43e2e.svg";